import { createGlobalStyle } from 'styled-components';
 
const GlobalStyle = createGlobalStyle`
  h1 {
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 28px;
    color: red;
  }
`;
 
export default GlobalStyle;

export const defaultStyle = {
  fonts: {
    fontFamily: "Poppins",
    fontStyle: "normal",
    color: "red"
  }
}